"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ServiceConfig_1 = __importDefault(require("./ServiceConfig"));
var cookie_1 = __importDefault(require("cookie"));
var ConstService_1 = require("../consts/ConstService");
var ManagerConfiger_1 = __importDefault(require("../manager/ManagerConfiger"));
var ServiceAdapter = (function () {
    function ServiceAdapter(options) {
        this.tokenSource = 'test';
        this.serverFlag = '';
        this.parentFlag = '';
        this.cookieObj = {};
        this.csrfValue = '';
        this.options = options;
        this.updateDomain();
    }
    ServiceAdapter.prototype.updateDomain = function () {
        if (!this.domain) {
            if (typeof window === 'undefined') {
                this.domain = ManagerConfiger_1.default.domain;
            }
            else {
                if (window) {
                    var nextData = window['__NEXT_DATA__'];
                    if (nextData && nextData.runtimeConfig) {
                        ManagerConfiger_1.default.updatePublicRuntimeConfig(nextData.runtimeConfig);
                        this.domain = ManagerConfiger_1.default.domain;
                    }
                    else {
                        this.domain = ManagerConfiger_1.default.domain;
                    }
                }
            }
        }
    };
    ServiceAdapter.prototype.registerSecurity = function (params) {
        var req = params.req;
        var query = params.query;
        var res = params.res;
        var isServer = this.getServerStatus(params);
        var token = '';
        if (req && req.headers) {
            if (isServer) {
                this.serverFlag = ConstService_1.ServiceConst.SERVER_MODE;
            }
            else {
                this.serverFlag = ConstService_1.ServiceConst.CLIENT_MODE;
            }
            if (req.headers[ConstService_1.ServiceConst.HEADER_TOKEN_KEY]) {
                token = req.headers[ConstService_1.ServiceConst.HEADER_TOKEN_KEY];
            }
            else {
                if (query && query.token) {
                    token = query.token;
                }
            }
        }
        if (req && req.getRsessionService && req.getRedisService) {
            this.tempGetRedisService = req.getRedisService;
            this.tempGetRsessionService = req.getRsessionService;
            this.tempTransportService = new req.getTransporter(req.getRedisService, req.getRsessionService);
            this.transporter = this.tempTransportService;
            var templayHeaders = __assign({}, req.headers);
            if (req.rSession) {
                this.tempTransportService.saveRession(req.rSession, templayHeaders);
            }
        }
        this.tokenSource = token;
        this.updateCookieValue(req, res);
        this.parentFlag = this.getParentFlag(req);
        if (!this.tokenSource && query) {
            this.tokenSource = query.token;
        }
        this.options.baseUrl = this.getServerAddress(req);
        this.parseByClient(req, res);
    };
    ServiceAdapter.prototype.getLoginInfo = function (params) {
        var req = params ? params.req : {};
        if (req) {
            if (req.rSession) {
                return req.rSession;
            }
            if (req.cookies) {
                return this.getParsedUserInfo(req.cookies.rsessionid, req.cookies.userId);
            }
            if (req && req.headers && req.headers.cookie) {
                var cookiesStr = req.headers.cookie;
                if (cookiesStr) {
                    var cookieParseResult = cookie_1.default.parse(cookiesStr || '');
                    if (cookieParseResult) {
                        return this.getParsedUserInfo(cookieParseResult.rsessionid, cookieParseResult.userId);
                    }
                }
            }
        }
        if (params && !params.req && !params.res && window) {
            var cookiesStr = window.document.cookie || '';
            if (cookiesStr) {
                var cookieParseResult = cookie_1.default.parse(cookiesStr || '');
                if (cookieParseResult) {
                    return this.getParsedUserInfo(cookieParseResult.rsessionid, cookieParseResult.userId);
                }
            }
        }
        return undefined;
    };
    ServiceAdapter.prototype.getParsedUserInfo = function (rsessionid, userId, userType) {
        if (userType === void 0) { userType = 'weixin'; }
        return {
            sessionId: rsessionid,
            user: { userType: userType, userId: userId }
        };
    };
    ServiceAdapter.prototype.getTemplayHeaders = function () {
        if (this.serverFlag === ConstService_1.ServiceConst.SERVER_MODE && this.tempTransportService) {
            return this.tempTransportService.gerTempHeaders();
        }
        return {};
    };
    ServiceAdapter.prototype.getTransportData = function (type, configData, paramsData) {
        if (configData === void 0) { configData = {}; }
        if (paramsData === void 0) { paramsData = ''; }
        return __awaiter(this, void 0, void 0, function () {
            var requestHeader, templayHeaders, transportResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.transporter) {
                            console.log('this.transporter is null..', this.transporter, configData.headers);
                            return [2, {}];
                        }
                        requestHeader = {
                            headers: {}
                        };
                        templayHeaders = this.getTemplayHeaders();
                        requestHeader.headers = __assign(__assign({}, templayHeaders), configData.headers);
                        requestHeader.method = type;
                        requestHeader['Content-Type'] = 'application/json;charset=utf-8';
                        switch (type) {
                            case ConstService_1.ServiceConst.GET:
                                requestHeader.query = paramsData || {};
                                break;
                            case ConstService_1.ServiceConst.POST:
                                requestHeader.body = paramsData || {};
                                break;
                            case ConstService_1.ServiceConst.PUT:
                                requestHeader.body = paramsData || {};
                                break;
                            case ConstService_1.ServiceConst.DELETE:
                                requestHeader.query = paramsData || {};
                                break;
                            case ConstService_1.ServiceConst.HEAD:
                                requestHeader.query = paramsData || {};
                                break;
                            case ConstService_1.ServiceConst.PATCH:
                                requestHeader.params = paramsData || {};
                                break;
                            default:
                                requestHeader.body = paramsData || {};
                                break;
                        }
                        if (!(this.serverFlag === ConstService_1.ServiceConst.SERVER_MODE && this.tempTransportService)) return [3, 2];
                        return [4, this.tempTransportService.getTransportByServer(requestHeader)];
                    case 1:
                        transportResult = _a.sent();
                        return [3, 4];
                    case 2: return [4, this.transporter.getTransportData(requestHeader)];
                    case 3:
                        transportResult = _a.sent();
                        _a.label = 4;
                    case 4: return [2, transportResult];
                }
            });
        });
    };
    ServiceAdapter.prototype.parseByClient = function (req, res) {
        if (!req && !res && window) {
            this.options.baseUrl = window.location.protocol + "//" + window.location.host;
            if (window.location) {
                this.parentFlag = window.location.pathname;
            }
            this.cookiesValue = window.document.cookie || '';
            this.csrfValue = this.getCsrfValue(this.cookiesValue);
        }
    };
    ServiceAdapter.prototype.updateCookieValue = function (req, res) {
        if (req && req.headers && req.headers.cookie) {
            this.cookiesValue = req.headers.cookie;
        }
        if (this.cookiesValue) {
            this.cookieObj = this.parseCookie(this.cookiesValue);
        }
        if (req && req.cookies) {
            this.cookieObj = req.cookies;
        }
        if (req && req.csrfToken) {
            this.csrfValue = req.csrfToken();
            res.locals.csrf = this.csrfValue;
            res.cookie(ConstService_1.ServiceConst.HEADER_SEC_CSRF_KEY, this.csrfValue, { maxAge: ConstService_1.ServiceConst.ONE_WEEK_TIME, httpOnly: false });
        }
    };
    ServiceAdapter.prototype.parseCookie = function (cookiesValue) {
        if (cookiesValue === void 0) { cookiesValue = ''; }
        var output = {};
        var pair = '';
        cookiesValue.split(/\s*;\s*/).forEach(function (pairValue) {
            pair = pairValue.split(/\s*=\s*/);
            output[pair[0]] = pair.splice(1).join('=');
        });
    };
    ServiceAdapter.prototype.getParentFlag = function (req) {
        var parentFlag = '';
        if (req) {
            if (req.baseUrl) {
                parentFlag = req.baseUrl;
            }
            if (req.originalUrl) {
                parentFlag = req.originalUrl;
            }
            if (req.url) {
                parentFlag = req.url;
            }
            if (req.route && req.route.path) {
                parentFlag = req.route.path;
            }
        }
        return parentFlag;
    };
    ServiceAdapter.prototype.getServerAddress = function (req) {
        if (req && req.headers && req.headers[ConstService_1.ServiceConst.HEADER_X_PORT]) {
            var realPort = req.headers[ConstService_1.ServiceConst.HEADER_X_PORT];
            var realPortList = realPort.split('-');
            if (realPortList.length > 0) {
                realPort = realPortList[1];
            }
            realPort = "http://127.0.0.1:" + realPort;
            return realPort;
        }
        return '';
    };
    ServiceAdapter.prototype.getServerStatus = function (params) {
        if ((params && params.req && params.res) || typeof window === 'undefined') {
            return true;
        }
        return false;
    };
    ServiceAdapter.prototype.addCsrf = function (request) {
        if (request && request.headers) {
            request.headers[ConstService_1.ServiceConst.HEADER_TOKEN_KEY] = this.tokenSource || '';
            if (this.serverFlag && this.cookiesValue) {
                request.headers.cookie = this.cookiesValue;
            }
            request.headers[ConstService_1.ServiceConst.HEADER_TOKEN_KEY] = this.csrfValue;
            request.headers[ConstService_1.ServiceConst.HEADER_TOKEN_XSRF_KEY] = this.csrfValue;
            request.headers[ConstService_1.ServiceConst.HEADER_TOKEN_X_CSRF_KEY] = this.csrfValue;
            request.headers[ConstService_1.ServiceConst.HEADER_TOKEN_X_XSRF_KEY] = this.csrfValue;
            request.headers[ConstService_1.ServiceConst.HEADER_PARENT] = this.parentFlag;
            request.headers[ConstService_1.ServiceConst.HEADER_TRACE_ID] = this.getUUID();
            request.headers[ConstService_1.ServiceConst.HEADER_SERVER_FLAG] = this.serverFlag;
            request.headers[ConstService_1.ServiceConst.HEADER_CLIENT_START_TIME] = Date.now();
        }
        return request;
    };
    ServiceAdapter.prototype.getCsrfValue = function (optionsValue) {
        var options = cookie_1.default.parse(optionsValue || '');
        if (options !== true && typeof options !== 'object') {
            return undefined;
        }
        if (options[ConstService_1.ServiceConst.HEADER_SEC_CSRF_KEY]) {
            return options[ConstService_1.ServiceConst.HEADER_SEC_CSRF_KEY];
        }
        return '';
    };
    ServiceAdapter.prototype.getToken = function () {
        return this.tokenSource;
    };
    ServiceAdapter.prototype.getUUID = function () {
        var s = [];
        var hexDigits = '0123456789abcdef!@#$%^&*()_+-';
        var hashLength = 36;
        var hashHex = 0x10;
        var pos14 = 14;
        var pos19 = 19;
        var pos8 = 8;
        var pos13 = 13;
        var pos18 = 18;
        var pos23 = 23;
        for (var i = 0; i < hashLength; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * hashHex), 1);
        }
        s[pos14] = '4';
        s[pos19] = hexDigits.substr((s[pos19] & 0x3) | 0x8, 1);
        s[pos8] = s[pos13] = s[pos18] = s[pos23] = '-';
        var uuid = s.join('');
        return uuid;
    };
    Object.defineProperty(ServiceAdapter.prototype, "apiService", {
        get: function () {
            var _this = this;
            if (!this.apiServiceInstance) {
                this.apiServiceInstance = ServiceConfig_1.default.getAxios();
                this.apiServiceInstance.defaults.withCredentials = true;
                this.apiServiceInstance.interceptors.request.use(function (request) {
                    return _this.addCsrf(request);
                }, function (error) {
                    return error;
                });
                this.apiServiceInstance.interceptors.response.use(function (response) {
                    if (response && response.headers) {
                        response.headers[ConstService_1.ServiceConst.HEADER_CLIENT_END_TIME] = Date.now();
                    }
                    return response;
                }, function (error) {
                    return error;
                });
            }
            return this.apiServiceInstance;
        },
        enumerable: true,
        configurable: true
    });
    ServiceAdapter.prototype.updateConfig = function (url) {
        if (this.options.isLocalHost) {
            return url;
        }
        var baseUrl = this.options.baseUrl || '';
        var resultUrl = "" + baseUrl + url;
        return resultUrl;
    };
    return ServiceAdapter;
}());
exports.ServiceAdapter = ServiceAdapter;
//# sourceMappingURL=ServiceAdapter.js.map